import React, {useContext} from "react";
import {instructionLinks, instructions, wgInstructionLinks} from "../config";
import UserData from "../../../../store/User/UserData";

export const CloudOnboardingInstructions = ({ connectorType }) => {
  const [userData] = useContext(UserData);
  const isWatchguard = userData?.tenantConfig?.is_watchguard

  return (
    <div className="cloud-instructions">
      <span className="instructions-title">ADD AN INTEGRATION</span>
      <div className="info-text">
        {instructions[connectorType].text}{" "}
        <a
          href={isWatchguard ? wgInstructionLinks[connectorType] : instructionLinks[connectorType]}
          target="_blank"
          rel="noreferrer"
          className="link instructions"
        >
          {"FULL INSTRUCTIONS »"}
        </a>
      </div>

      <div className="info-sub">
        {"Please fill in all fields below. After adding, click the"}{" "}
        <span>{"TEST"}</span> {"button to verify the integration."}
      </div>
    </div>
  );
}
